var _circle, _path, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#C5E3FF",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13C15.2486 10.8839 13.7856 11.6531 14.8942 7L8.81774 7C7.89681 11.8193 9.25012 10.9883 9.45632 13",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7998,
    cy: 10.2002,
    r: 1,
    transform: "rotate(-90 11.7998 10.2002)",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7292 21.6444L17.9576 16.0407C17.9807 15.4729 17.5267 15 16.9584 15H7.13257C6.53115 15 6.06579 15.5271 6.14027 16.1239L6.87371 22",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 12.75C4.92157 12.75 4.25 13.4216 4.25 14.25C4.25 15.0784 4.92157 15.75 5.75 15.75H18.25C19.0784 15.75 19.75 15.0784 19.75 14.25C19.75 13.4216 19.0784 12.75 18.25 12.75H5.75Z",
    fill: "#C5E3FF",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredPromotion);
export default __webpack_public_path__ + "static/media/ic-colored-promotion.77b2cbc24b272eff60cb6e5148ce955f.svg";
export { ForwardRef as ReactComponent };